import { createRoutine } from 'redux-saga-routines';

export const fetchVisitHistory = createRoutine('FETCH_VISIT_HISTORY');
